<template>
  <div>
    <div class="cashout-header-bg"></div>
    <div class="white-fore-loans"><img alt="White background image" src="https://i.imgur.com/Xq6hO8N.png" style="border-radius: 30px;">
      <div class="loans-body">
        <div class="loans-body1">
          <div class="h1 loans-header">
            <hr2 :data-column="cashout_h1" style="font-size: 1.3em">{{ BranchPage.cashout_h1 }}</hr2>
          </div>
          <div class="p1 loans-para1">
            <p :data-column="cashout_p1" style="font-size: .9em">{{ BranchPage.cashout_p1 }}</p>
          </div>
        </div>
        <div class="loans-gold-line"></div>
        <div class="loans-body2">
          <div class="p1 loans-para2">
            <p :data-column="cashout_p2" style="font-size: .9em" v-html="BranchPage.cashout_p2"></p>
          </div>
          <div class="p1 loans-para3">
            <p :data-column="loans_general" style="font-size: .9em">{{ BranchPage.loans_general }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="loans-footer">
      <div class="h1 loan-footer-header">
        <hr2>Leading You Home</hr2>
      </div>
      <div class="double_button">
        <div class="gold-line5"></div>
        <a role="button" @click="sendTo('/find-loan')">
            <kButton :data-column="'about_button3'" :size="null" :class="'custom-size3'" :theme-color="'null'"
              :rounded="'large'">View Loans</kButton></a>
        <div class="gold-line5"></div>
      </div>
    </div>
    <div class="blue-chunk"></div>
    <FooterComp></FooterComp>
  </div>
</template>

<script>
import '@progress/kendo-theme-default/dist/all.css';
import apiService from '../api/api.service';
import { Button } from '@progress/kendo-vue-buttons';
import FooterComp from "../components/Footer_Comp.vue";

export default {
  name: "Proccess-Page",
  components: {
    FooterComp,
    'kButton': Button
  },


  data: function () {
    const searchParams = new URLSearchParams(window.location.search)
    var orgid = 'HQ';
    if(searchParams.has('org')){
      orgid = searchParams.get('org');
    }

    return {
      show: true,
      orgid: orgid,
      BranchPage: {},
      isLoading: false,

    };
  },

  mounted() {
    this.GetBranchPage();
  },
  methods: {
    GetBranchPage() {
      return apiService.GetBranchPage(this.orgid)
        .then(res => {
          this.BranchPage = res.data.data[0];
          this.isLoading = false;
        }).catch(error => {
          this.isLoading = false;
          console.log(error)
        });
    },
    sendTo(url) {
      const searchParams = new URLSearchParams(window.location.search)
      if(searchParams.has('org')){
        window.location.href = url + '/?org=' + searchParams.get('org');
      }
      else
        window.location.href = url;
    }
  }
};
</script>

<style>
.cashout-header-bg {
  background-image: url('https://cdn.corporatefinanceinstitute.com/assets/cash-out-refinance.jpeg');
  background-position: 50%;
  background-size: cover;
  width: 100%;
  margin-top: 5%;
  height: 580px;
}

.white-fore-loans {
  max-width: 1200px;
  height: 600px;
  top: -150px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}

.loans-body {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  top: -420px;
}

.loans-body1 {
  display: flex;
  justify-content: center;
  gap: 150px;
}

.loans-body2 {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-left: 120px;
  margin-top: 80px;
}

.loans-header {
  width: 380px;
}

.loans-para1 {
  width: 450px;
}

.loans-para2{
  width: 60%;
}

.loans-gold-line {
  border-top: 10px solid #f9c62b;
  height: 2px;
  width: 70px;
  position: relative;
  margin-left: 120px;
}

.loans-footer {
  justify-content: center;
  position: relative;
  margin-right: auto;
  margin-left: auto;
  text-align: center;
  margin-bottom: 90px;
}

.blue-chunk {
  background-color: #051d39;
  height: 60px;
  width: 100%;
}

@media (max-width: 430px){
  .loans-header-bg{
    height: 400px;
  }
  .white-fore-loans{
    border-radius: 0px;
    margin-left: -10px;
  }
  .loans-gold-line{
    display: none;
  }
  .loans-body1{
    gap: 40px !important;
    align-items: center;
    flex-direction: column;
  }
  .loans-body2{
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 40px;
    margin-left: 0px !important;
    margin-top: 0px !important;
    text-align: center
  }
  .loans-header{
    width: 100vw;
    text-align: center;
  }
  .p1.loans-para1{
    text-align: center;
    width: 80vw;
  }
  .p1.loans-para2{
    align-items: center;
    width: 90vw;
  }
  .loans-para3{
    width: 80vw;
    margin-right: 0px !important;
  }
  .loans-footer{
    margin-top: 130px;
  }
}
</style>